import { useMediaQuery, useTheme } from '@/ui/primitives';

export const layoutModeTokens = { compact: 'compact', medium: 'medium', wide: 'wide' } as const;

export type LayoutMode = keyof typeof layoutModeTokens;

export const useLayoutMode = (): LayoutMode => {
  const theme = useTheme();
  const isCompact = useMediaQuery(theme.breakpoints.down('sm'));
  const isWide = useMediaQuery(theme.breakpoints.up('lg'));
  if (isCompact) return layoutModeTokens.compact;
  if (isWide) return layoutModeTokens.wide;
  return layoutModeTokens.medium;
};
